import { render, staticRenderFns } from "./DefinitionConfig.vue?vue&type=template&id=2c3a14c4"
import script from "./DefinitionConfig.vue?vue&type=script&lang=js"
export * from "./DefinitionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports